module.exports = __webpack_public_path__ + "img/category-fishing-game.bb7de824.png";